module.exports = __webpack_public_path__ + "img/shane-rounce-DNkoNXQti3c-unsplash.472f9bfd.jpg";